export default __webpack_public_path__ + "static/media/BMMF-Phone02.024048d4.webp";